import React from "react";

const WorkDescription = ({ description }) => {
  return <p class="text-base font-normal text-gray-600"> → {description}</p>;
};

export default WorkDescription;
